// import React, { useState, useEffect } from "react";
// import { Select } from "@windmill/react-ui";
// import VehicleCategoryServices from "services/VehicleCategoryServices";

// const SelectVehicleCategory = ({
//   register,
//   name,
//   label,
//   selectedVehicle,
//   readOnly,
//   selectedOptions,
//   ...props
// }) => {
//   const [allVehicleCategory, setVehicleCategory] = useState([]);
//   useEffect(() => {
//     async function fetchVehicleCategory() {
//       try {
//         const response = await VehicleCategoryServices.getAllVehicleCategory();
//         setVehicleCategory(response.data); // Assuming the API response contains an array of profiles
//       } catch (error) {
//         console.error("Error fetching category:", error);
//       }
//     }

//     fetchVehicleCategory();
//   }, []);

//   return (
//     <Select
//       className="border h-10 text-sm focus:outline-none block w-full bg-white-100 dark:bg-white border-transparent focus:bg-white"
//       name={name}
//       {...register(`${name}`, {
//         required:
//           !selectedVehicle || selectedVehicle === "undefined"
//             ? `${label} is required!`
//             : false,
//       })}
//       value={selectedVehicle ? String(selectedVehicle) : ""}
//       {...props}
//       disabled={readOnly}
//     >
//       <option value="">Select Vehicle</option>
//       {Array.isArray(allVehicleCategory) && allVehicleCategory.length > 0 ? (
//         allVehicleCategory
//           .filter(
//             (category) =>
//               !selectedOptions.includes(String(category.id)) ||
//               String(category.id) === selectedVehicle
//           )
//           .map((category) => (
//             <option key={category.id} value={category.id}>
//               {category.vehicle_type_name}
//             </option>
//           ))
//       ) : (
//         <option>Loading...</option>
//       )}
//     </Select>
//   );
// };

// export default SelectVehicleCategory;


import React, {
  useEffect,
  useState,
} from "react";

import { Select } from "@windmill/react-ui";

import VehicleCategoryServices from "services/VehicleCategoryServices";

const SelectVehicleCategory = ({
  register,
  name,
  label = "Vehicle Type",
  selectedVehicle,
  readOnly,
  selectedOptions = [],
  ...props
}) => {
  const [
    allVehicleCategory,
    setVehicleCategory,
  ] = useState([]);

  const [loading, setLoading] =
    useState(true); 

  useEffect(() => {
    let isMounted = true;

    const fetchVehicleCategory = async () => {
      try {
        setLoading(true);

        const response =
          await VehicleCategoryServices.getAllVehicleCategory();

        if (isMounted) {
          setVehicleCategory(
            Array.isArray(response?.data)
              ? response.data
              : []
          );
        }
      } catch (error) {
        console.error(
          "Error fetching vehicle category:",
          error
        );

        if (isMounted) {
          setVehicleCategory([]);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchVehicleCategory();

    return () => {
      isMounted = false;
    };
  }, []);

  const currentValue =
    selectedVehicle !== undefined &&
    selectedVehicle !== null &&
    selectedVehicle !== "" &&
    selectedVehicle !== "undefined" &&
    selectedVehicle !== "null"
      ? String(selectedVehicle)
      : "";

  const availableVehicles =
    Array.isArray(allVehicleCategory)
      ? allVehicleCategory.filter(
          (category) => {
            const categoryId =
              String(category.id);

            return (
              !selectedOptions.includes(
                categoryId
              ) ||
              categoryId === currentValue
            );
          }
        )
      : [];

  return (
    <Select
      className="
        border
        h-10
        text-sm
        focus:outline-none
        block
        w-full
        bg-white
        dark:bg-white
        border-transparent
        focus:bg-white
      "
      name={name}
      {...register(name, {
        required: !currentValue
          ? `${label} is required!`
          : false,
      })}
      value={currentValue}
      disabled={readOnly || loading}
      {...props}
    >

      <option value="">
        {loading
          ? "Loading..."
          : "Select Vehicle"}
      </option>

      {!loading &&
        availableVehicles.map(
          (category) => (
            <option
              key={category.id}
              value={String(category.id)}
            >
              {category.vehicle_type_name}
            </option>
          )
        )}
    </Select>
  );
};

export default SelectVehicleCategory;